import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyC7PfowJUqvKejtag4M5kf133UVJjeR_Ek",
  authDomain: "qwer-16470.firebaseapp.com",
  projectId: "qwer-16470",
  storageBucket: "qwer-16470.firebasestorage.app",
  messagingSenderId: "300481536011",
  appId: "1:300481536011:web:d61e5251a86fafbfd0a70e",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app); // ��� ������ �������

const db = getFirestore(app);
const functions = getFunctions(app);

export { auth, db, functions };
export default app;